// import { constant } from "common/constant";
// import * as yup from "yup";

// export const jobProfileSchema = yup.object({
//   postingTitle: yup.string().required(constant.requiredTitle),
//   department: yup.string().required(constant.requiredDepartment),
//   hiringManager: yup.string().required(constant.requiredHiringManager),
//   assignedRecruiter: yup.string().required(constant.requiredAssignedRecruiter),
//   industry: yup.string().required(constant.requiredIndustry),
//   salary: yup.string().required(constant.requiredSalary),
//   description: yup.string().required(constant.requiredDescription),
//   requirements: yup.string().required(constant.requiredRequirements),
//   benefits: yup.string().required(constant.requiredBenefits),
//   attachments: yup.string(),
// });

import * as Yup from "yup"

export const jobProfileSchema = Yup.object().shape({
  // Required fields
  postingTitle: Yup.string()
    .required("Posting title is required"),

  department: Yup.string().required("Department is required"),

  hiringManager: Yup.string().required("Hiring manager is required"),

  industry: Yup.string().nullable(),

  customIndustry: Yup.string().nullable(),

  salary: Yup.string()
    .required("Salary per annum is required")
    .matches(/^\d+$/, "Salary must be a valid number")
    .max(8, "Salary cannot exceed 8 digits"),

  description: Yup.string()
    .required("Job description is required")
    .test('no-only-spaces', 'Job description cannot contain only spaces', (value) => {
      if (!value) return false;
      const textOnly = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return textOnly.length > 0;
    })
    .max(5000, "Job description cannot exceed 5000 characters"),

  benefits: Yup.string()
    .nullable()
    .test('no-only-spaces', 'Benefits cannot contain only spaces', (value) => {
      if (!value) return true;
      const textOnly = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return textOnly.length > 0;
    })
    .max(5000, "Benefits cannot exceed 5000 characters"),

  // Optional fields with validation
  // titleSelect: Yup.string().nullable(),

  assignedRecruiter: Yup.string().required("Assigned recruiter is required"),

  numberOfPosition: Yup.number()
    .nullable()
    .required("Number of positions are required")
    .positive("Number of positions must be positive")
    .integer("Number of positions must be a whole number")
    .max(999, "Number of positions cannot exceed 3 digits (999)"),

  targetDate: Yup.date()
    .required("Target date is required")
    .min(
      new Date(new Date().setHours(0, 0, 0, 0)),
      "Target date cannot be in the past"
    ),

  openDate: Yup.date()
    .required("Open date is required")
    .max(new Date(), "Date opened cannot be in the future"),

  jobStatus: Yup.string().required("Job status is required"),

  jobType: Yup.array()
    .of(Yup.string())
    .min(1, "At least one job type is required")
    .required("Job type is required"),

  workExperience: Yup.string().required("Work experience is required"),
  sharedWithEmployees: Yup.boolean(),

  // Update the requiredSkills validation in your schema
  requiredSkills: Yup.array()
    .of(Yup.string())
    .min(1, "At least one skill is required")
    .required("Required skills are required")
    .test(
      "maxTotalLength",
      "All skills combined must not exceed 500 characters",
      (value) => {
        if (!value) return true; // Just in case Yup runs this before `.required`
        const totalLength = value.join(", ").length;
        return totalLength <= 500;
      }
    ),

  // Address fields
  city: Yup.string()
    .nullable(),

  state: Yup.string()
    .nullable(),

  country: Yup.string().nullable(),

  // zipCode: Yup.string()
  //   .nullable()
  //   .matches(/^\d{5}(-\d{4})?$/, "Please enter a valid zip code"),
  zipCode: Yup.string()
    .nullable()
    .test(
      "zipCode",
      "Pincode must be exactly 6 digits",
      (value) => {
        if (!value) return true; // Allow empty (optional field)
        const pinCodeRegex = /^\d{6}$/; // Exactly 6 digits
        return pinCodeRegex.test(value);
      }
    ),


  requirements: Yup.string()
    .nullable()
    .test('no-only-spaces-if-exists', 'Requirements cannot contain only spaces', (value) => {
      if (!value) return true; // Allow empty since nullable
      const textOnly = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return textOnly.length > 0;
    })
    .max(5000, "Requirements cannot exceed 5000 characters"),

  // Attachment fields
  jobSummaryAttachment: Yup.string().nullable(),

  otherAttachment: Yup.string().nullable(),
  preScreeningQuestions: Yup.string()
    .nullable()
    .test('no-only-spaces-if-exists', 'Pre-screening questions cannot contain only spaces', (value) => {
      if (!value) return true; // Allow empty since nullable
      const textOnly = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      return textOnly.length > 0;
    })
    .max(5000, "Pre-screening questions cannot exceed 5000 characters"),
})
